
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yendo",
      function () {
        return require("private-next-pages/yendo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yendo"])
      });
    }
  